(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-share__copy');
    if (!button) return;

    const url = button.getAttribute('data-share-copy');
    if (!url || !navigator.clipboard) return;

    navigator.clipboard.writeText(url).then(() => {
      button.classList.add('is-copied');
      setTimeout(() => button.classList.remove('is-copied'), 1500);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
